const and = <A>(f: (a: A) => boolean) => (g: (a: A) => boolean) => (a: A) => f(a) && g(a);

export default and;
